import ManagementFee from './ManagementFee.view';

export default ManagementFee;